var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ snote: !_vm.integrated }},[_c('div',{staticClass:"note"})])}
var staticRenderFns = []

export { render, staticRenderFns }